module.exports = __webpack_public_path__ + "static/media/layout-2.20a36141.svg";